export function isExternalSession(existsResponse) {
    if (!existsResponse)
        return false;
    if (existsResponse.user && existsResponse.user.type === "EXTERNAL") {
        return true;
    }
    return false;
}
const SESSION_SCOPE_FULL = "fileee:full";
const SESSION_SCOPE_EXTERNAL_CONVERSATION = "fileee:conversation:external:";
export function hasFullAccessScope(existsResponse) {
    if (!existsResponse)
        return false;
    if (existsResponse.scopes &&
        existsResponse.scopes.includes(SESSION_SCOPE_FULL)) {
        return true;
    }
    return false;
}
export function isExternalConversationSession(existsResponse) {
    if (!existsResponse)
        return false;
    if (existsResponse.user &&
        existsResponse.user.type === "EXTERNAL" &&
        existsResponse.scopes &&
        existsResponse.scopes.length > 0) {
        return existsResponse.scopes.some((scope) => scope.startsWith(SESSION_SCOPE_EXTERNAL_CONVERSATION));
    }
    return false;
}
export function getExternalConversationIdsFromSessionScope(existsResponse) {
    if (!existsResponse)
        return [];
    if (!isExternalConversationSession(existsResponse)) {
        return [];
    }
    return existsResponse.scopes
        .filter((scope) => scope.startsWith(SESSION_SCOPE_EXTERNAL_CONVERSATION))
        .map((scope) => scope.replace(SESSION_SCOPE_EXTERNAL_CONVERSATION, ""))
        .filter(Boolean);
}
//# sourceMappingURL=js-session-utils.js.map